import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
    Notification,
    NotificationRepository,
} from 'src-ironside/repositories/notification.repository';

@Component({
    selector: 'app-notification-list',
    templateUrl: './notification-list.component.html',
    styleUrls: ['./notification-list.component.css'],
})
export class NotificationListComponent implements OnInit {
    @Output() onClosed = new EventEmitter();
    constructor(private notificationRepository: NotificationRepository) {}

    notifications?: Notification[];

    ngOnInit(): void {
        this.notificationRepository.getMyNotifications().subscribe((res) => {
            this.notifications = res.content;
        });
    }

    close() {
        this.onClosed?.emit();
    }

    read(n: Notification) {
        if (!n.isUnread) return;

        n.isUnread = false;
        this.notificationRepository.markAsRead([n]);
    }

    markAllAsRead() {
        if (this.notifications) {
            this.notificationRepository
                .markAsRead(this.notifications.filter((n) => { 
                    if (n.isUnread) {
                        n.isUnread = false;
                        return true;
                    }
                    return false;
                }));                
        }
    }

    hasUnread() {
        return this.notifications?.some((n) => n.isUnread);
    }
}
